import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

const popularComics = comics.slice(0, 8);

const accentColors = [
  'bg-rose-50',
  'bg-emerald-50',
  'bg-stone-100',
  'bg-amber-50',
  'bg-sky-50',
  'bg-violet-50',
  'bg-orange-50',
  'bg-teal-50',
];

export default function PopularGrid() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-14">
          <p className="text-[10px] font-medium text-stone-400 uppercase tracking-[0.2em] mb-3">
            热门推荐
          </p>
          <h2 className="text-3xl md:text-5xl font-[family-name:var(--font-heading)] text-stone-800 leading-tight">
            本周热门 <i className="ri-fire-line text-amber-500" style={{ fontStyle: 'normal' }}></i>
          </h2>
          <p className="mt-3 text-stone-400 text-sm">精选最受欢迎的韩国漫画，每本都值得一读</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {popularComics.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group cursor-pointer"
              data-product-shop=""
            >
              <div className={`relative overflow-hidden rounded-xl ${accentColors[idx % accentColors.length]} mb-3 aspect-[3/4]`}>
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={comic.title + ' - 韩漫屋韩国漫画'}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-white/90 backdrop-blur-sm rounded-full text-[10px] font-medium text-stone-700 whitespace-nowrap">
                    {comic.category}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="flex items-center gap-0.5 px-2 py-1 bg-black/60 backdrop-blur-sm rounded-full text-[10px] font-medium text-white whitespace-nowrap">
                    <i className="ri-star-fill text-yellow-400 text-[10px]"></i> {comic.rating}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-stone-800 group-hover:text-stone-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="mt-1 text-xs text-stone-400">
                {comic.latestChapter} · {comic.author}
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/category/langman-aiqing"
            className="inline-flex items-center gap-2 px-8 py-3 border border-stone-300 rounded-full text-sm font-medium text-stone-600 hover:bg-stone-50 hover:border-stone-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多热门漫画 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}